import React, { useState, useEffect } from 'react';
import axios from '../api/axios';
import { useAlert } from '../context/AlertContext';
import './Permissions.css';

function Permissions() {
  const [roles, setRoles] = useState([]);
  const [availablePermissions, setAvailablePermissions] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const alert = useAlert();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [rolesRes, permsRes] = await Promise.all([
        axios.get('/api/permissions/roles'),
        axios.get('/api/permissions/available')
      ]);
      setRoles(rolesRes.data);
      setAvailablePermissions(permsRes.data);
    } catch (error) {
      console.error('Error fetching permissions:', error);
      alert.error('Fehler beim Laden der Berechtigungen');
    } finally {
      setLoading(false);
    }
  };

  const togglePermission = async (roleId, permission) => {
    const role = roles.find(r => r.id === roleId);
    if (!role) return;

    const hasPermission = role.permissions.includes(permission);
    const updatedPermissions = hasPermission
      ? role.permissions.filter(p => p !== permission)
      : [...role.permissions, permission];

    try {
      await axios.put(`/api/permissions/roles/${roleId}`, {
        permissions: updatedPermissions
      });

      setRoles(roles.map(r =>
        r.id === roleId ? { ...r, permissions: updatedPermissions } : r
      ));

      alert.success('Berechtigung aktualisiert');
    } catch (error) {
      console.error('Error updating permission:', error);
      alert.error('Fehler beim Aktualisieren');
    }
  };

  const hasPermission = (role, permission) => {
    return role.permissions.includes(permission);
  };

  return (
    <div className="permissions">
      <div className="page-header">
        <h2>🔐 Berechtigungen</h2>
        <p>Verwalte Rollen und Berechtigungen</p>
      </div>

      {loading ? (
        <div className="loading-state">
          <div className="spinner"></div>
          <p>Lade Berechtigungen...</p>
        </div>
      ) : (
        <div className="permissions-content">
          <div className="roles-list">
            <h3>Rollen</h3>
            {roles.map(role => (
              <div
                key={role.id}
                className={`role-card ${selectedRole?.id === role.id ? 'active' : ''}`}
                onClick={() => setSelectedRole(role)}
              >
                <h4>{role.display_name}</h4>
                <p>{role.permissions.length} Berechtigungen</p>
              </div>
            ))}
          </div>

          {selectedRole && (
            <div className="permissions-editor">
              <h3>Berechtigungen für {selectedRole.display_name}</h3>
              <div className="permissions-grid">
                {availablePermissions.map(category => (
                  <div key={category.category} className="permission-category">
                    <h4>{category.category}</h4>
                    <div className="permission-list">
                      {category.permissions.map(permission => (
                        <label key={permission} className="permission-item">
                          <input
                            type="checkbox"
                            checked={hasPermission(selectedRole, permission)}
                            onChange={() => togglePermission(selectedRole.id, permission)}
                          />
                          <span>{permission.split('.')[1]}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Permissions;
